<template>
  <div>
    <img class="header" src="@/img/izixun/studyCenter/header.png" />
    <div class="schoolCenter_part1">
      <pageTitle title="家门口的学习中心" subTitle="全程跟进与服务、及时反馈与沟通，让您更了解孩子学习情况" />
      <div class="schoolCenter_part1_content">
        <div class="tab-container">
          <ul class="schoolCenter_part1_content_citylist">
            <li :class="{
                active: val===city
            }" class="schoolCenter_part1_content_citylist_item" v-for="(val,key) in cityList" :key="key" @click="handleTagCity(key)">{{val}}</li>
          </ul>
          <ul class="tab-tt clearfix">
            <li class="item" v-for="(district,idx) in schoolData" :key="idx" :class="{active:idx==districtIndex}" @click="handleDistrict(idx)">{{district.name}}</li>
          </ul>
          <div class="tab-content-box">
            <ul class="tab-content nine-items clearfix" >
              <li :class="{
                  active: subIdx==studyCenterIndex
              }" v-for="(item,subIdx) in studyCenters" :key="subIdx" @click="handleStudyCenter(subIdx)">
                <a href="javascript:void(0);" :class="{active:subIdx==studyCenterIndex}">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="map-container clearfix">
          <baidu-map
            :center="mapReady ? center : {}"
            :zoom="15"
            class="bm-view"
            ak="wsvmuyhyveTeFQwoGhkZPUjzE06y9FTI"
            :scroll-wheel-zoom="true"
            @ready="handle"
          >
            <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT" />
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT" />
            <bm-marker :position="mapReady ? center : {}" :dragging="false" />
          </baidu-map>
          <div id="myMap" class="fl"></div>
          <div class="content fl clearfix">
            <h3 class="txt-lh26 txt-111 pb15">{{curSchoolCenter.name}}</h3>
            <p class="para district-para">{{curSchoolCenter.address}}</p>
            <p class="para tel-para mt10">4000-121-121</p>
            <p class="map-courses-title">课程形式</p>
            <p class="map-courses">
              <span>1对1</span>
              <span>8人班</span>
              <span>在线课</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmScale from 'vue-baidu-map/components/controls/Scale'   // 比例尺组件
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import { getCities, getSchoolDistrict } from '@/request/index.js';
import pageTitle from "./components/pageTitle.vue";

export default {
  name: "studyCenter",
  components: {
    BaiduMap,
    BmScale,
    BmNavigation,
    BmMarker,
    pageTitle
  },
  data() {
    return {
      center: {lng: null, lat: null} ,
      city:'',
      cityList:{},
      data:[],
      schoolData:[],
      studyCenters: [],
      curSchoolCenter:{},
      districtIndex:0,
      studyCenterIndex:0,
      mapReady:false
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    handle(){
      this.mapReady = true
    },
    async fetch() {
      this.cityList= await this.getCityList()
      if (this.cityList[this.cityCode]) {
          this.city = this.cityList[this.cityCode]
          this.getMapData(this.cityCode);
      } else {    // 定位不在我们所有分校的城市
          this.city = this.cityList['010'];
          this.getMapData('010');
      }
    },
    getCityList() {
      return new Promise((resolve) => {
        getCities({sign: 'f926b3d4d6868b0b0486fa7e982bd874'}).then(res => {
          let _citylist = res.data.data.tcities
          let cityObj = {}
          _citylist.forEach(item => {
              cityObj[item.cityCode] = item.cityName
          });
          resolve(cityObj)
        })
      })
    },
    getMapData(cityCode) {
      getSchoolDistrict({cityCode: cityCode}).then((res)=>{
        let data=res.data;
        if (data.errcode==0) {
          this.schoolData = data.data.schoolList
          this.handleDistrict(0)
          this.mapInit()
        } else {
          // this.$IzkNotice.error({message:data.msg});
        }
      });
    },
    mapInit() {
      let idx = this.districtIndex
      let subIdx = this.studyCenterIndex
      this.curSchoolCenter=this.schoolData[idx].schools[subIdx];
      let x= Number(this.curSchoolCenter.longitude);
      let y= Number(this.curSchoolCenter.latitude);
      
      this.center.lng = x;
      this.center.lat = y;
    },
    handleDistrict(idx) {
      this.districtIndex=idx;

      this.studyCenters = this.schoolData[idx].schools
      this.studyCenterIndex = 0;
      this.mapInit();
    },
    handleStudyCenter(subIdx) {
      this.studyCenterIndex=subIdx;
      this.mapInit();
    },
    handleTagCity(cityCode) {
      this.city=this.cityList[cityCode];
      this.getMapData(cityCode);
    },
  }
};
</script>

<style lang="scss" scoped>
.bm-view {
  width: 600px;
  height: 400px;
}

.clearfix {
  overflow: hidden;
}

.schoolCenter_part1_content {
  width:1200px;
  margin: 0 auto;
  &_citylist {
      width: 1200px;
      display: flex;
      flex-wrap: wrap;

      &_item {
        width: 118px;
        height: 40px;
        line-height: 38px;
        border-radius:5px;
        border:1px solid #999;
        font-size:16px;
        font-weight:400;
        color:#666;
        text-align: center;
        margin: 0 15px 14px 0;
        cursor: pointer;

        &:nth-child(9n) {
          margin-right: 0;
        }

        &:hover {
          background: #cd0014;
          color: #fff;
          border-color:  #cd0014;
        }

        &.active {
          background: #cd0014;
          color: #fff;
          border-color:  #cd0014;
        }
      }
  }
}

.tab-container{
  .tab-tt{
    padding:0;
    border-bottom: 2px solid #f9f9fb;
    .item{
      padding: 26px 0 22px;
      float:left;
      margin-right:40px;
      color:#222;
      font-size:16px;
      cursor: pointer;
      position: relative;
      
      &:hover,&.active{
        color:#cd0014;
      }

      &.active {
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #cd0014;
        }
      }
    }
  }
  .tab-content-box{
    .tab-content{
      padding: 30px 0 16px;
      li{
        float:left;
        background:#f8f9fb;
        color:#666;
        text-align: center;
        padding: 0 14px;
        margin: 0 14px 14px 0;
        border-radius: 5px;
        height: 32px;
        line-height: 32px;

        &.active {
          background:rgba(205,0,20,1);
          color: #fff;
          border: rgba(205,0,20,1);

          a{ 
            color: #fff!important;
          }
        }
        a{
          font-size:14px;
          line-height:30px;
          color:#555;
          text-decoration: none
        }
      }
    }
  }
}

.map-container{
    padding-bottom: 80px;
    display: flex;
    
    #map{
      width:600px;
      height:380px;
      border:1px solid #f3f3f3;
      .BMap_bubble_content{
        .infoWindow-tt{
          color:#cd0014;
          font-size:16px;
          line-height:26px;
          padding-bottom:5px;
        }
        .infoWindow-content{
          font-size:14px;
          color:#666;
          line-height:24px;
        }
        .infoWindow-buttons{
          padding-top:10px;
          padding-bottom:5px;
        }
        .infoWindow-btn{
          float:left;
          font-size:14px;
          color:#fff;
          height:36px;
          line-height:36px;
          padding:0 10px;
          border-radius: 3px;
          background:#cd0014;
          &:hover{
            background:#f5800c;
          }
          &.right-btn{
            background:#f44343;
            margin-left:10px;
            &:hover{
              background:#f33030;
            }
          }
        }
      }
    }
    .content{
      padding: 54px 0 20px 72px;
      flex: 1;
      background-color: #F9F9FB;

      h3 {
        font-size: 22px;
        font-weight: 400;
        color: #222;
        margin-bottom: 22px;
      }
    }
    .para{
      color:#222;
      font-size:16px;
      line-height:42px;
      padding: 0 20px 0 40px;
      position:relative;
      &:before{
        content:"";
        position:absolute;
        left:0;
      }
      &.district-para:before, &.tel-para:before{
        top:7px;
        width:26px;
        height:26px;
      }
      &.district-para:before{
        background:url('../../img/izixun/studyCenter/address.png') no-repeat;
        background-size: 100% 100%;
      }
      &.tel-para:before{
        background:url('../../img/izixun/studyCenter/tel.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .map-courses-title {
      font-size: 22px;
      font-weight: 400;
      color: #222;
      margin: 55px 0 24px;
    }
    .map-courses {
      overflow: hidden;
      span {
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #cd0014;
        border-radius: 4px;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 400;
        margin-right: 16px;
        text-align: center;
      }
    }
}
.school-detail{
  background:#f7f7f7;
  padding:50px 0 0;
  .tit{
    color:#111;
    font-size:36px;
    line-height:70px;
    position:relative;
    &:before{
      content:"";
      position:absolute;
      bottom:0;
      left:50%;
      width:120px;
      height:5px;
      background:#cd0014;
      margin-left:-60px;
    }
  }
  .con{
    background:#fff;
    .c-tit{
      font-size:20px;
      color:#111;
      line-height:30px;
      padding:36px 40px 10px;
    }
    .c-para{
      font-size:14px;
      color:#999;
      line-height:26px;
      padding:0px 40px 30px;
    }
  }
}
</style>